import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';

const ImpersonationBanner: React.FC = () => {
  const { isImpersonating, impersonatedEmail, endImpersonation, role } = useAuth();
  const [loading, setLoading] = useState(false);

  if (!isImpersonating) return null;

  const handleEnd = async () => {
    try {
      setLoading(true);
      await endImpersonation();
      // endImpersonation() already navigates to '/' — no duplicate needed
    } catch (err) {
      console.error('Failed to end impersonation:', err);
      setLoading(false);
    }
  };

  const roleLabel = role ? role.replace('_', ' ').replace(/\b\w/g, c => c.toUpperCase()) : 'User';

  return (
    <div className="w-full bg-amber-500 text-white px-4 py-2 flex items-center gap-3 text-sm font-medium shadow-md flex-shrink-0">
      <span className="text-lg">👁️</span>
      <span>
        Impersonating <strong>{impersonatedEmail}</strong>
      </span>
      <span className="px-2 py-0.5 rounded-full bg-amber-700 text-amber-100 text-xs font-semibold">
        {roleLabel}
      </span>
      <span className="text-amber-200 text-xs">— actions you take are logged as this user</span>
      <button
        onClick={handleEnd}
        disabled={loading}
        className="ml-auto flex items-center gap-1.5 bg-surface text-amber-700 dark:text-amber-300 hover:bg-amber-50 hover:dark:bg-amber-900/30 disabled:opacity-60 px-3 py-1 rounded-full text-xs font-semibold transition-colors"
      >
        {loading ? (
          <>
            <svg className="animate-spin h-3 w-3" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            Ending...
          </>
        ) : (
          <>✕ End Impersonation</>
        )}
      </button>
    </div>
  );
};

export default ImpersonationBanner;
